import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function ReaderValue() {
  const readerStates = ['Interested, but not ready for a call', 'Trying to apply one idea', 'Needs the right next step'];
  return <section className="py-24 px-6 max-w-4xl mx-auto relative" data-id="element-397">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-398">
        <PathThread data-id="element-399" />
      </div>

      <div className="text-center mb-20" data-id="element-400">
        <Reveal data-id="element-401">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-402">
            Some readers are not ready to buy. <br data-id="element-403" />
            <span className="italic text-seaglass" data-id="element-404">
              But they are ready to keep going.
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-405">
          <div className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto space-y-6" data-id="element-406">
            <p data-id="element-407">
              A reader can be interested without being ready to book a call.
            </p>
            <ul className="space-y-3 text-left max-w-lg mx-auto bg-white p-6 rounded-2xl shadow-[0_8px_20px_-12px_rgba(26,40,56,0.1)] border border-gray-100" data-id="element-408">
              <li className="flex items-start gap-3" data-id="element-409">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-410"></div>
                They may need to understand where they fit.
              </li>
              <li className="flex items-start gap-3" data-id="element-411">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-412"></div>
                They may need to try the idea in their own situation.
              </li>
              <li className="flex items-start gap-3" data-id="element-413">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-414"></div>
                They may need to see whether the framework applies to their
                team.
              </li>
              <li className="flex items-start gap-3" data-id="element-415">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-416"></div>
                They may need language for the problem before they are ready to
                ask for help.
              </li>
            </ul>
            <p className="font-serif text-2xl text-navy pt-6" data-id="element-417">
              The path after the book gives them a useful next step before they
              are ready for a sales conversation.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-24" data-id="element-418">
        {readerStates.map((state, idx) => <Reveal key={idx} delay={0.1 * idx} data-id="element-419">
            <div className="bg-white border border-gray-100 rounded-2xl p-8 text-center shadow-[0_12px_24px_-12px_rgba(26,40,56,0.15)] hover:-translate-y-1 transition-transform duration-300 flex items-center justify-center min-h-[120px]" data-id="element-420">
              <span className="font-serif text-lg text-navy" data-id="element-421">{state}</span>
            </div>
          </Reveal>)}
      </div>

      <Reveal delay={0.2} data-id="element-422">
        <div id="quick-check-3" className="scroll-mt-32" data-id="element-423">
          <ReaderPathCheck id="q3" checkLabel="Quick Check · 3 of 8" question="After someone engages with the book, do they leave with something useful they can do this week?" answers={[{
          id: 'a',
          label: 'A',
          text: 'Not usually.'
        }, {
          id: 'b',
          label: 'B',
          text: 'Sometimes. I give general advice, exercises, or resources.'
        }, {
          id: 'c',
          label: 'C',
          text: 'Yes, but the next move is mostly the same for everyone.'
        }, {
          id: 'd',
          label: 'D',
          text: 'Yes. Their next move changes based on their situation or readiness.'
        }]} confirmationText="Saved. This helps check whether the book gives readers a useful next step." data-id="element-424" />
        </div>
      </Reveal>
    </section>;
}